import React from 'react';
import { PushApiFeatureFlag } from '@app/api-mgmt/components/push-api/types/push-api-models';

interface FeatureFlagsProviderProps {
  featureFlags: PushApiFeatureFlag[];
  children: React.ReactNode;
}

const FeatureFlagsContext = React.createContext<PushApiFeatureFlag[]>([]);

export const FeatureFlagsProvider = ({
  featureFlags,
  children,
}: FeatureFlagsProviderProps) => {
  return (
    <FeatureFlagsContext.Provider value={featureFlags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlags = () => {
  const context = React.useContext(FeatureFlagsContext);

  if (context === undefined) {
    throw new Error(
      `useFeatureFlags must be used within a FeatureFlagsProvider`,
    );
  }

  return context;
};
